<template>
  <v-layout class="partner-new-container">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" sm="9" md="7" lg="5" class="py-0 text-center">
          <v-card class="card--round" elevation="0">
            <template v-if="loading">
              <v-card-text class="text-center">
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-card-text>
            </template>
            <template
              v-else-if="!lastApplication || lastApplication.status !== 'await'"
            >
              <v-card-title class="justify-center">
                <v-col>
                  <v-img
                    class="d-inline-block mb-6"
                    style="width: 35%"
                    src="/admin/assets/img/partner/partner@0.33x.png"
                  />
                  <h2>¿Quiere ser parte?</h2>
                </v-col>
              </v-card-title>
              <v-card-text>
                <p>
                  Como partner de QueResto.com, cada vez que una tienda que crea
                  su carta digital en QueResto.com a través de su link adquiere
                  cualquiera de nuestros planes, usted obtiene una parte del monto
                  pagado y del que continue pagando mientras dure su plan.
                </p>
                <v-btn color="primary" @click="apply" :loading="sending"
                  >Enviar mi solicitud</v-btn
                >
              </v-card-text>
            </template>
            <template v-else>
              <v-card-title class="justify-center">
                <h2>Su solicitud está siendo evaluada</h2>
              </v-card-title>
              <v-card-text>
                <p class="mb-0">
                  Recibirá un email y podrá acceder al panel una vez que sea
                  aceptado.
                </p>
              </v-card-text>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-layout>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { IPartnerApplication } from '../../interfaces/IPartnerApplication';
  import PartnersService from '../../api/services/partners.service';
  import { IUser } from '../../interfaces/IUser';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';

  @Component
  export default class PartnerNew extends Vue {
    @Prop() user: IUser;
    partnersService = new PartnersService();
    loading = false;
    sending = false;
    lastApplication: IPartnerApplication = null;

    async created() {
      this.loading = true;

      this.lastApplication = await this.partnersService.getLastApplication();

      this.loading = false;
    }

    async apply() {
      this.sending = true;

      try {
        this.lastApplication = await this.partnersService.apply();
      } catch (e) {
        console.error(e);
        vueData.serverError(e, 'Ocurrió un error al enviar la solicitud');
      }

      this.sending = false;
    }
  }
</script>
